/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from 'zod'
import { apiResponseV4Schema } from './apiResponseV4Schema'
import { loginResponseV4ApiResponseObjectV4Schema } from './loginResponseV4ApiResponseObjectV4Schema'
import { verifyLoginCodeRequestV4Schema } from './verifyLoginCodeRequestV4Schema'

export const authLoginVerifyCodeStatus200Schema = loginResponseV4ApiResponseObjectV4Schema.describe(
  'Typed variant of EP.Models.ViewModels.ApiResponseObjectV4, used in `[ProducesResponseType]` so Swagger renders\r\nthe real `result` schema instead of the bare `object` (which the UI shows as `"string"`).\r\nWire shape is identical to the untyped envelope — this only carries the type for the schema generator.'
)

export const authLoginVerifyCodeStatus400Schema = apiResponseV4Schema.describe(
  'V4 response envelope — same contract as the legacy EP.Models.ViewModels.ApiResponse minus the dead\r\n`planNeeded` field. V4 endpoints must never expose `planNeeded`; legacy endpoints keep\r\nthe old envelope untouched.'
)

export const authLoginVerifyCodeResponseSchema = authLoginVerifyCodeStatus200Schema

export const authLoginVerifyCodeErrorSchema = authLoginVerifyCodeStatus400Schema

export const authLoginVerifyCodeBodySchemaJsonPatchJson = verifyLoginCodeRequestV4Schema

export const authLoginVerifyCodeBodySchemaJson = verifyLoginCodeRequestV4Schema

export const authLoginVerifyCodeBodySchemaJson2 = verifyLoginCodeRequestV4Schema

export const authLoginVerifyCodeBodySchemaJson3 = verifyLoginCodeRequestV4Schema

export const authLoginVerifyCodeBodySchema = z.union([
  authLoginVerifyCodeBodySchemaJsonPatchJson,
  authLoginVerifyCodeBodySchemaJson,
  authLoginVerifyCodeBodySchemaJson2,
  authLoginVerifyCodeBodySchemaJson3,
])
